import {
  Dispatch,
  MouseEvent,
  ReactNode,
  SetStateAction,
  useCallback,
  useEffect,
  useRef,
} from 'react';
import { animated, useSpring } from 'react-spring';

import * as S from './styles';

interface Props {
  children: ReactNode;
  modalIsOpen: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  size: 'md' | 'lg' | 'xl' | string;
}

const Modal = ({ modalIsOpen, setShowModal, size, children }: Props) => {
  const modalRef = useRef(null);
  const animation = useSpring({
    config: {
      duration: 250,
    },
    opacity: modalIsOpen ? 1 : 0,
    transform: modalIsOpen ? 'translateY(0%)' : 'translateY(-100%)',
  });

  const closeModal = (
    e: MouseEvent<HTMLDivElement, globalThis.MouseEvent>,
  ): void => {
    if (modalRef.current === e.target) {
      setShowModal(false);
    }
  };

  const keypress = useCallback(
    e => {
      if (e.key === 'Escape' && modalIsOpen) {
        setShowModal(false);
      }
    },
    [modalIsOpen, setShowModal],
  );

  useEffect(() => {
    document.addEventListener('keydown', keypress);
    return () => document.removeEventListener('keydown', keypress);
  }, [keypress]);

  return (
    <>
      {modalIsOpen && (
        <S.Overlay ref={modalRef} onClick={closeModal}>
          <animated.div style={animation}>
            <S.Content size={size}>
              <S.CloseModalButton
                type="button"
                aria-label="Fechar modal"
                onClick={() => setShowModal(false)}
              >
                &times;
              </S.CloseModalButton>
              {children}
            </S.Content>
          </animated.div>
        </S.Overlay>
      )}
    </>
  );
};

export default Modal;
